export const resultQuestions = [
    {
        questionNumber: "1",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: true,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "2",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "3",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: true,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "4",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "5",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "6",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "7",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    },
    {
        questionNumber: "8",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor sit",
                isCorrect: false,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: false,
                wasPicked: true,
            },
            {
                optionText: "Lorem ipsum dolor",
                isCorrect: true,
                wasPicked: false,
            },
            {
                optionText: "Lorem ipsum",
                isCorrect: false,
                wasPicked: false,
            },
        ]
    }
]